<p>form-scale-stat works!</p>
